<template>
    <div id="user-edit-tab-info">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-col w-full mb-base">
                    <template>
                        
                        <vs-table stripe  max-items="4" pagination search :data="getAllDeductions"  >
                            
                            <template slot="thead">
                                <vs-th>Type</vs-th>
                                <vs-th>Amount</vs-th>
                                <vs-th>Period</vs-th>
                                <vs-th>OneTime?</vs-th>
                                <vs-th>Hold?</vs-th>
                                <vs-th>Active?</vs-th>
                                <vs-th>Include In 13th Month?</vs-th>
                                <vs-th>Include In Final Pay?</vs-th>
                                <vs-th>Effectivity Date</vs-th>
                                <vs-th>Expiry Date</vs-th>
                                <vs-th>Resume Date</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].deductionsTypeId">
                                        {{ deductionsTypeName(data[indextr].deductionsTypeId).deductionsTypeName }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].deductionsAmount">
                                        {{ data[indextr].deductionsAmount }}
                                    </vs-td>
                                    
                                    <vs-td :data="data[indextr].periodId">
                                        {{ periodName(data[indextr].periodId).periodName }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].isOneTime">
                                        <vs-checkbox v-model="data[indextr].isOneTime" class="pointer-events-none"/>
                                    </vs-td>
                                    <vs-td :data="data[indextr].isHold">
                                        <vs-checkbox v-model="data[indextr].isHold" class="pointer-events-none" />
                                    </vs-td>
                                    <vs-td :data="data[indextr].isActive">
                                        <vs-checkbox v-model="data[indextr].isActive" class="pointer-events-none" /><!--  How to disabled checkbox -->
                                    </vs-td>
                                    <vs-td :data="data[indextr].isIncludedIn13thMonth">
                                        <vs-checkbox v-model="data[indextr].isIncludedIn13thMonth" class="pointer-events-none" />
                                    </vs-td>
                                    <vs-td :data="data[indextr].isIncludedInFinalPay">
                                        <vs-checkbox v-model="data[indextr].isIncludedInFinalPay" class="pointer-events-none" />
                                    </vs-td>
                                    <vs-td :data="data[indextr].effectivityDate">
                                        {{data[indextr].effectivityDate | fulldate}}
                                    </vs-td>
                                    <vs-td :data="data[indextr].expirationDate">
                                        {{data[indextr].expirationDate | fulldate}}
                                    </vs-td>
                                    <vs-td :data="data[indextr].resumeDate">
                                        {{data[indextr].resumeDate | fulldate}}
                                    </vs-td>
                                   
                                    <vs-td>
                                        <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}"  >
                                            <vx-tooltip text="Edit"><feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" /></vx-tooltip>
                                            <feather-icon v-show="getDateDiff(data[indextr].createdOn) <= 10 ? true : false" icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </template>
                </div>
            </div>
        </div>   
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button type="gradient" color="primary" @click="promptAddNewDeductions()"  icon-pack="feather" icon="icon-plus">Add</vs-button>
            </div>    
        </div>


    <!-- ADD EARNINGS -->
        <vs-prompt
                  class="email-compose"
                  title="Add Deductions"
                  accept-text= "Submit"
                  @accept="onAddRecord"
                  :is-valid="validForm"
                  :active.sync="activePromptAddRecord">
                  <vx-card title="Please fill-out the following information">
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Deductions Type</span> <span style="color:red">*</span>
                            <v-select name="deductions type" v-validate="'required'" class="w-full" v-model="deductionsType" label="deductionsTypeName" :options="getAllDeductionsTypeLookup" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('deductions type')">{{ errors.first('deductions type') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Amount</span><span style="color:red">*</span>
                            <vs-input name="amount" v-validate="'max_value:1000000'" class="w-full" v-model="deductionsAmount" />
                            <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Period</span><span style="color:red">*</span>
                            <v-select name="period" v-validate="'required'" class="w-full" v-model="period" label="periodName" :options="getAllPeriodByPaymentMode" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('period')">{{ errors.first('period') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Effectivity Date</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="effectivityDate" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Expiry Date</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="expirationDate" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Date Resume :</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="resumeDate" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full md:mt-8">
                            <div class="flex">
                                <vs-checkbox v-model="isOneTime">One Time?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isHold" >Hold?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isActive"  >Active?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isIncludedIn13thMonth" >Included In 13th Month?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isIncludedInFinalPay"  >Included In Final Pay?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                  </vx-card>
              </vs-prompt>
    <!-- END ADD EARNINGS -->
    <!-- EDIT EARNINGS -->
        <vs-prompt
                  class="email-compose"
                  title="Edit Deductions"
                  accept-text= "Submit"
                  @accept="onUpdateRecord"
                  :is-valid="validForm"
                  :active.sync="activePromptEditRecord">
                  <vx-card title="You may update the following information">

                  
                  <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Deductions Type</span> <span style="color:red">*</span>
                            <v-select name="deductions type" v-validate="'required'" class="w-full" v-model="deductionsType" label="deductionsTypeName" :options="getAllDeductionsTypeLookup" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('deductions type')">{{ errors.first('deductions type') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Amount</span><span style="color:red">*</span>
                            <vs-input name="amount" v-validate="'max_value:1000000'" class="w-full" v-model="deductionsAmount" />
                            <span class="text-danger text-sm" v-show="errors.has('amount')">{{ errors.first('amount') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Period</span><span style="color:red">*</span>
                            <v-select name="period" v-validate="'required'" class="w-full" v-model="period" label="periodName" :options="getAllPeriodByPaymentMode" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('period')">{{ errors.first('period') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Effectivity Date</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="effectivityDate" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Expiry Date</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="expirationDate" />
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span class="text-sm">Date Resume :</span>
                            <flat-pickr  :config="configdateTimePicker" class="w-full"  placeholder="Select Date" v-model="resumeDate" />
                        </div>
                        <div class="vx-col sm:w-1/2 w-full md:mt-8">
                            <div class="flex">
                                <vs-checkbox v-model="isOneTime">One Time?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isHold" >Hold?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isActive"  >Active?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isIncludedIn13thMonth" >Included In 13th Month?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isIncludedInFinalPay"  >Included In Final Pay?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                  </vx-card>
              </vs-prompt>
    <!-- END EDIT EARNINGS -->
   </div>               
</template>
<script>

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    props: {
        paymentMode: {
            type: Number,
            required: true
        },
        userId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            selected: [],

            deductionsId: 0,
            deductionsType: [],
            deductionsAmount: 0,
            period: [],
            isHold: false,
            isOneTime: false,
            isActive: true,
            isIncludedIn13thMonth: false,
            isIncludedInFinalPay: false,
            effectivityDate: null,
            expirationDate:null,
            resumeDate: null,
            activePromptAddRecord: false,
            activePromptEditRecord: false,

            configdateTimePicker: {
                allowInput: true
            },
            currentDate: moment().utc().format('YYYY-MM-DD'),
        }
    },
    created() {
        // this.$vs.loading()
        this.$store.dispatch('lookup/getAllDeductionsType').catch((err) => { console.log(err)})
        // this.$store.dispatch('lookup/getAllPeriodLookup').catch((err) => { console.log(err)})
        this.$store.dispatch('payroll/getAllDeductions')
            .then(() => {
            })
            .catch((err) => { console.log(err)})
         
        // this.$vs.loading.close()
    },
    components: {
         'v-select': vSelect,
        Datepicker,
        flatPickr,
    },
    computed: {
        getAllDeductions() {
            return this.$store.getters['payroll/getDeductionsByUserId'](this.userId)
        },
        getAllDeductionsTypeLookup() {
            return this.$store.state.lookup.getAllDeductionsType
        },
        getAllPeriodByPaymentMode() {
            return this.$store.getters['lookup/periodLookupByPaymentMode'](this.paymentMode) 
        },
        deductionsTypeName() {
            return (id) => this.$store.getters['lookup/deductionsTypeLookup'](id) 
        },
        periodName() {
            return (id) => this.$store.getters['lookup/periodLookup'](id)
        },
        validForm() {

        },
        getDateDiff(){
            return (createdOn) => {
                var oneDay = 1
                if (createdOn !== null && this.currentDate !== null) {
                        var date1 = new Date(moment(createdOn).format("MM-DD-YYYY"))
                        var date2 = new Date(moment(this.currentDate).format("MM-DD-YYYY"))

                        var timeDiff = Math.abs(date2.getTime() - date1.getTime())
                        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
                        if (diffDays !== 'NaN') {
                           return diffDays + oneDay  
                        } else { return 0 }
                }
            }

        }
    },
    methods: {
        promptAddNewDeductions() {
            this.activePromptAddRecord = true
        },
        editRecord(id) {
            const e = this.$store.getters['payroll/getDeductionsById'](id)
            this.deductionsType            = this.deductionsTypeName(e.deductionsTypeId),
            this.deductionsAmount          = e.deductionsAmount,
            this.isOneTime               = e.isOneTime,
            this.period                  = this.periodName(e.periodId),
            this.isHold                  = e.isHold,
            this.resumeDate              = e.isHold ? this.resumeDate : null,
            this.effectivityDate         = e.effectivityDate,
            this.expirationDate          = e.expirationDate,
            this.isActive                = e.isActive,
            this.isIncludedIn13thMonth   = e.isIncludedIn13thMonth,
            this.isIncludedInFinalPay    = e.isIncludedInFinalPay,
            this.dateDeactivated         = e.dateDeactivated ,
            this.dateReActivated         = e.dateReActivated ,
            this.userId                  = e.userId
            this.deductionsId              = e.id
            this.activePromptEditRecord = true
        },
        confirmDeleteRecord(id) {
            this.$vs.loading()
            //console.log(id)
             this.$store.dispatch('payroll/DeleteEmployeeDeductions', id)
            .then(res => {
                this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Deductions Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        if(error.response.status == 400) {
                            this.$vs.notify({
                            title: 'Information',
                            text: 'Cannot be deleted. The item is in used',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'warning'                  
                            })
                        } else {
                            this.$vs.notify({
                            title: 'Error',
                            text: 'test',
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                            })
                        }
                        
                })
        },
        onAddRecord() {
            const e = {
                deductionsTypeId          : this.deductionsType.deductionsTypeId,
                deductionsAmount          : this.deductionsAmount,
                isOneTime               : this.isOneTime,
                periodId                : this.period.periodId,
                isHold                  : this.isHold,
                resumeDate              : this.isHold ? this.resumeDate : null,
                effectivityDate         : this.effectivityDate,
                expirationDate          : this.expirationDate,
                isActive                : this.isActive,
                isIncludedIn13thMonth   : this.isIncludedIn13thMonth,
                isIncludedInFinalPay    : this.isIncludedInFinalPay,
                dateDeactivated         : this.dateDeactivated ,
                dateReActivated         : this.dateReActivated ,
                userId                  : this.userId,
                currentUserId           : this.$store.state.AppActiveUser.uid
            } 
           this.$store.dispatch('payroll/AddEmployeeDeductions', e)
              .then((res) => {
                  this.$vs.loading.close()
              })

        },
        onUpdateRecord() {
            const e = {
                deductionsTypeId          : this.deductionsType.deductionsTypeId,
                deductionsAmount          : this.deductionsAmount,
                isOneTime               : this.isOneTime,
                periodId                : this.period.periodId,
                isHold                  : this.isHold,
                resumeDate              : this.isHold ? this.resumeDate : null,
                effectivityDate         : this.effectivityDate,
                expirationDate          : this.expirationDate,
                isActive                : this.isActive,
                isIncludedIn13thMonth   : this.isIncludedIn13thMonth,
                isIncludedInFinalPay    : this.isIncludedInFinalPay,
                dateDeactivated         : this.dateDeactivated ,
                dateReActivated         : this.dateReActivated ,
                userId                  : this.userId,
                id                      : this.deductionsId,
                currentUserId           : this.$store.state.AppActiveUser.uid

            } 
           this.$store.dispatch('payroll/UpdateEmployeeDeductions', e)
              .then((res) => {
                  this.$vs.loading.close()
              })

        },

    }
}
</script>